import React from 'react'
import { Route, Routes,  } from 'react-router'
import AssociateLandingPage from '../app/associate/dashboard/pages/AssociateLandingPage'
import ClinicDetailsPage from '../app/clinic/pages/ClinicDetailsPage'
import AssociatedClinicPage from '../app/associate/profile/pages/AssociatedClinicPage'
import ProfilePage from '../app/associate/profile/pages/ProfilePage'
import { useAppData } from '../context/AppDataContext'
import { useAuth } from '../context/AuthContext'
import ChooseRolePage from '../app/associate/profile/pages/ChooseRolePage'
import BusinessHoursPage from '../app/associate/schedule/pages/BusinessHoursPage'
import BusinessHolidayPage from '../app/associate/schedule/pages/BusinessHolidayPage'
import ClientDashboardPage from '../app/client/pages/ClientDashboardPage'
import ClientSearchPage from '../app/client/pages/ClientSearchPage'
import ClientListPage from '../app/client/pages/ClientListPage'
import ClientInfoPage from '../app/client/pages/ClientInfoPage'







function AssociateRoutes() {

  const {associatedClinicList,associateProfile} = useAppData();
  

  return (
    //(associateProfile && associateProfile.role == null) ?
    //  <ChooseRolePage/>
    //  :
      <>
        {(associatedClinicList && associatedClinicList.length > 0 ) ?
          <Routes>
            {/* Business Details */}
            <Route path="/" element={<AssociateLandingPage/>}></Route>
            <Route path="/clinic/:clinicId" element={<ClinicDetailsPage/>}></Route>
            <Route path="/profile" element={<ProfilePage/>}></Route>
            <Route path="/profile/associated-clinic" element={<AssociatedClinicPage/>}></Route>
            <Route path="/profile/choose-role" element={<ChooseRolePage/>}></Route>


            <Route path="/schedule/business-hours" element={<BusinessHoursPage/>}></Route>
            <Route path="/schedule/business-holiday" element={<BusinessHolidayPage/>}></Route>

            <Route path="/client/dashboard" element={<ClientDashboardPage/>}></Route>
            <Route path="/client/search" element={<ClientSearchPage/>}></Route>
            <Route path="/client/list" element={<ClientListPage/>}></Route>

            <Route path="/client/details/:clientId" element={<ClientInfoPage/>}></Route>
            

          </Routes>
          :
          <Routes>
            <Route path="/" element={<AssociatedClinicPage/>}></Route>
          </Routes>
        }
      </>
    
  )
}

export default AssociateRoutes